import type { AggregateResult } from './weldParameterAggregator'
import type { UploadFormat } from './weldUpload/types'

/**
 * Patch weldparams.{weldId} after telemetry replace (Data360 re-import or TXT re-upload).
 * Resets tolerance and limits mode; preserves data360 metadata when present.
 */
export function buildWeldParamsSectionAfterTelemetryReplace(params: {
  existingRecord: Record<string, unknown>
  aggregate: AggregateResult
  sourceFilename: string
  uploadedAt: string
  passMappings: Record<string, string>
  uploadFormat?: UploadFormat
  sourceFilenames?: string[]
  data360?: Record<string, unknown>
}): Record<string, unknown> {
  const {
    existingRecord,
    aggregate,
    sourceFilename,
    uploadedAt,
    passMappings,
    uploadFormat = 'telemetry-txt',
    sourceFilenames,
    data360
  } = params
  const existingData360 =
    data360 ??
    (existingRecord.data360 && typeof existingRecord.data360 === 'object'
      ? (existingRecord.data360 as Record<string, unknown>)
      : undefined)

  return {
    ...existingRecord,
    source: 'upload',
    uploadFormat,
    aggregate,
    sourceFilename,
    ...(sourceFilenames ? { sourceFilenames } : {}),
    uploadedAt,
    passMappings,
    tolerance: '0%',
    pqrLimitsMode: 'minmax',
    ...(existingData360 ? { data360: existingData360 } : {})
  }
}
